import { ensureApplicantToken } from "./ensureApplicantToken";

/**
 * เปิดหน้าพิมพ์/รายงานของ admission2017 ที่บังคับ JWT
 * (แท็บใหม่ส่ง Authorization header ไม่ได้ — แนบ access_token ใน query)
 */

export function admissionAccessToken() {
  try {
    return localStorage.getItem("token") || "";
  } catch {
    return "";
  }
}

/** path ที่โดน RequireInternalAuth / RequirePartnerAuth */
function needsAccessToken(url) {
  const u = String(url || "");
  if (!u) return false;
  if (/[?&]access_token=/.test(u)) return false;
  if (/student_printbill|dashboard_printbill/i.test(u)) return true;
  if (/\/student(?:_|\/|$)/i.test(u)) return false;
  return (
    /\/dashboard_/i.test(u) ||
    /\/administrator_/i.test(u) ||
    /\/faculty_/i.test(u) ||
    /\/finance/i.test(u) ||
    /printregistrar/i.test(u) ||
    /printbill/i.test(u) ||
    /printlist/i.test(u)
  );
}

async function ensureToken(citizentOverride) {
  try {
    if (localStorage.getItem("token")) return localStorage.getItem("token");
    return await ensureApplicantToken(citizentOverride);
  } catch {
    return "";
  }
}

export function withAccessToken(url) {
  const token = admissionAccessToken();
  if (!url || !token) return url;
  if (!needsAccessToken(url)) return url;
  if (/[?&]access_token=/.test(url)) return url;
  const sep = String(url).includes("?") ? "&" : "?";
  return `${url}${sep}access_token=${encodeURIComponent(token)}`;
}

/**
 * เปิดหน้าพิมพ์ — ขอ JWT อัตโนมัติถ้ายังไม่มี
 * @param {string} url
 * @param {string} [target]
 * @param {string} [citizentOverride] เลขบัตรจากหน้า (เช่น present)
 */
export function openAdmissionPrint(url, target = "_blank", citizentOverride) {
  return ensureToken(citizentOverride).then((token) => {
    if (!token && needsAccessToken(url)) {
      window.alert(
        "ไม่พบโทเคนเข้าสู่ระบบ กรุณาเข้าใหม่ผ่านหน้าตรวจสอบสถานะ แล้วลองพิมพ์อีกครั้ง"
      );
      return null;
    }
    const finalUrl = token
      ? (() => {
          if (!needsAccessToken(url) || /[?&]access_token=/.test(url)) return url;
          const sep = String(url).includes("?") ? "&" : "?";
          return `${url}${sep}access_token=${encodeURIComponent(token)}`;
        })()
      : url;
    return window.open(finalUrl, target);
  });
}
